import { useEffect, useState } from 'react';

import { getReorder } from '../../../api/order/order.service';
import { Reorder } from '../../../api/order/order.types';
import { Async, Status } from '../../../types/data.types';

interface UseReorder {
  data?: Reorder;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useReorder = (orderId: number, isEnabled: boolean): UseReorder => {
  const [reorderOrder, setReorderOrder] = useState<Async<Reorder>>({
    status: Status.LOADING,
  });

  const isError = reorderOrder.status === Status.ERROR;
  const isLoading = reorderOrder.status === Status.LOADING && isEnabled;
  const isSuccess = reorderOrder.status === Status.SUCCESS;

  useEffect(() => {
    if (orderId && isLoading) {
      getReorder({ orderId })
        .then((data: Reorder) => {
          setReorderOrder({ data, status: Status.SUCCESS });
        })
        .catch(() => {
          setReorderOrder({ status: Status.ERROR });
        });
    }
  }, [orderId, isEnabled, isLoading]);

  const reorderData = isSuccess ? reorderOrder.data : undefined;

  return {
    data: reorderData,
    isError,
    isLoading,
    isSuccess,
  };
};
